// This component is used to render a text input with a number type and fix the issue with the number input for Persian language.
// Like ١٢٣٤٥٦٧٨٩٠ instead of 1234567890

import React, { memo } from 'react';
import Input from './input';

const InputTextNumber = (props: any) => {
   // Array of persian numbers
   const persianNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
   const handleKeyDown = (e: any) => {
      // if it is not number or dot or backspace or delete or tab or enter or left or right and not persian number
      if (
         e.key !== 'Backspace' &&
         e.key !== 'Delete' &&
         e.key !== 'Tab' &&
         e.key !== 'Enter' &&
         e.key !== 'ArrowLeft' &&
         e.key !== 'ArrowRight' &&
         e.key !== '.' &&
         (e.key < '0' || e.key > '9') &&
         !persianNumbers.includes(e.key)
      ) {
         e.preventDefault();
      }
      // only allow one dot
      else if (e.key === '.' && e.target.value.includes('.')) {
         e.preventDefault();
      }
   };

   const handleOnChange = (e: any) => {
      const value = e.target.value;
      // convert value persian number if any to english number and set it to the input
      e.target.value = value.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (w: string) {
         return persianNumbers.indexOf(w);
      });
      props.onChange(e);
   };

   return (
      <Input
         {...props}
         type="text"
         onKeyDown={e => {
            handleKeyDown(e);
         }}
         onChange={e => {
            handleOnChange(e);
         }}
      />
   );
};

export default memo(InputTextNumber);
